import { MenuSections } from '@thehubz/client/core';

export class MenuSettingsData {
  /* Menu setting configurations */
  static ASSET_GALLERY_MENU_SETTINGS: MenuSections[] = [
    {
      sectionId: 'displayOptions',
      sectionTitle: $localize`Display options`,
      section: [
        {
          menuId: 'grid_4',
          menuTitle: $localize`:view:Gallery (4 in row)`,
          selectedViewType: 'grid_4',
          menuIcon: 'grid_on',
          menuSection: 1,
        },
        {
          menuId: 'grid_8',
          menuTitle: $localize`:view:Gallery (8 in row)`,
          selectedViewType: 'grid_8',
          menuIcon: 'view_compact',
          menuSection: 1,
        },
      ],
    },
    {
      sectionId: 'sortBy',
      sectionTitle: $localize`Sort by`,
      section: [
        {
          menuId: 'sortByAlphabetically',
          menuTitle: $localize`:sort:Alphabetically`,
          selectedViewSection2: 'sortByAlphabetically',
          menuIcon: 'sort_by_alpha',
          menuSection: 2,
        },
        {
          menuId: 'sortByLastCreated',
          menuTitle: $localize`:sort:Last added`,
          selectedViewSection2: 'sortByLastCreated',
          menuIcon: 'sort',
          menuSection: 2,
        },
      ],
    },
  ];
}
